// Web twin of composeApp's HistoryPanel.kt.

package com.islamicmedia.site.components

import androidx.compose.runtime.Composable
import com.islamicmedia.shared.domain.model.AnalysesLayout
import com.islamicmedia.shared.presentation.AnalysisStripEntry
import com.islamicmedia.shared.presentation.HistoryItem
import com.islamicmedia.shared.presentation.TaskStatus
import com.islamicmedia.site.theme.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Composable
fun HistoryPanel(
    history: List<HistoryItem>,
    onItemClick: (HistoryItem) -> Unit
) {
    if (history.isEmpty()) return

    Div(attrs = {
        classes("card-hover")
        style {
            property("background", GradientCard)
            borderRadius(RadiusXLarge.unsafeCast<CSSNumeric>())
            padding(28.px)
            property("box-shadow", CardShadow)
            property("border", CardBorder)
        }
    }) {
        HistoryContent(
            history = history,
            onItemClick = onItemClick
        )
    }
}

/**
 * Maps a HistoryItem to the unified [AnalysisStripEntry] shape so the
 * dedicated History view renders cards via the same composable as the
 * SEARCH-screen strip.
 */
/** Internal, not private: the Settings preview renders real entries through the same
 *  mapper, so a card there can't disagree with the list it is previewing. */
internal fun HistoryItem.toStripEntry(onClick: () -> Unit): AnalysisStripEntry =
    AnalysisStripEntry(
        id = "h-$id",
        title = title,
        mediaType = mediaType,
        status = TaskStatus.COMPLETE,
        progressFraction = 1f,
        score = result.score,
        sortKey = timestamp,
        onClick = onClick,
        onCancel = null,
        coverUrl = result.coverUrl,
        quickCheck = result.quickCheck,
        kidScan = kidScan,
    )

@Composable
fun HistoryContent(
    history: List<HistoryItem>,
    onItemClick: (HistoryItem) -> Unit,
    /** The user's Settings choice. Applied here as well as on the strip so the two views of the
     *  same catalogue don't disagree about how it looks. */
    layout: AnalysesLayout = AnalysesLayout.GRID_2,
) {
    // Header
    Div(attrs = {
        style {
            padding(28.px, 28.px, 0.px)
        }
    }) {
        Div(attrs = {
            style {
                fontSize(18.px)
                fontWeight(700)
                property("background", GradientPrimary)
                property("-webkit-background-clip", "text")
                property("-webkit-text-fill-color", "transparent")
                property("background-clip", "text")
            }
        }) { Text("Recent Searches") }
    }

    // Card grid — same item composable as the search-screen strip.
    Div(attrs = {
        style {
            property("position", "relative")
            property("max-height", "560px")
            property("overflow-y", "auto")
            padding(20.px, 28.px, 28.px)
            property("-webkit-mask-image", "linear-gradient(to bottom, black 90%, transparent 100%)")
            property("mask-image", "linear-gradient(to bottom, black 90%, transparent 100%)")
        }
    }) {
        val entries = history
            .sortedByDescending { it.timestamp }
            .map { item -> item.toStripEntry(onClick = { onItemClick(item) }) }
        AnalysisCardGrid(entries, layout)
    }
}
